import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import SkipToContent from "@/components/SkipToContent";
import NavV2 from "@/components/homev2/NavV2";
import HeroV2 from "@/components/homev2/HeroV2";
import CredibilityV2 from "@/components/homev2/CredibilityV2";
import CreativeV2 from "@/components/homev2/CreativeV2";
import EcosystemV2 from "@/components/homev2/EcosystemV2";
import DifferentiationV2 from "@/components/homev2/DifferentiationV2";
import GuaranteeV2 from "@/components/homev2/GuaranteeV2";
import TestimonialsV2 from "@/components/homev2/TestimonialsV2";
import FounderV2 from "@/components/homev2/FounderV2";
import FaqV2 from "@/components/homev2/FaqV2";
import LeadFormV2 from "@/components/homev2/LeadFormV2";
import FooterV2 from "@/components/homev2/FooterV2";
import { faqV2Items } from "@/components/homev2/faqV2Data";
import { captureUtmParams } from "@/lib/analytics";

const Index = () => {
  useEffect(() => {
    captureUtmParams();
  }, []);

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "Agence 8020",
      description:
        "Agence marketing basée à Montréal : stratégie, contenu, publicité, génération de leads et optimisation pour les entreprises de services au Québec.",
      areaServed: "Québec, Canada",
      email: "maxim@agence8020.com",
      url: "https://agence8020.com",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqV2Items.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
  ];

  return (
    <>
      <SEOHead
        title="Agence 8020 | Agence marketing Montréal — Systèmes de leads prévisibles"
        description="On bâtit des systèmes prévisibles de génération de leads pour les entrepreneurs et professionnels ambitieux du Québec. Contenu organique + pub Meta + conversion."
        canonical="/"
        schemaJson={schema}
      />
      <SkipToContent />
      <div className="min-h-screen bg-background text-foreground" lang="fr-CA">
        <NavV2 />
        <main id="main-content">
          <HeroV2 />
          <CredibilityV2 />
          <CreativeV2 />
          <EcosystemV2 />
          <DifferentiationV2 />
          <GuaranteeV2 />
          <TestimonialsV2 />
          <FounderV2 />
          <FaqV2 />
          <LeadFormV2 />
        </main>
        <FooterV2 />
      </div>
    </>
  );
};

export default Index;
